<template>
  <div class="mt-3">
    <!-- Begin Uren's Footer Area -->
    <div class="uren-footer_area">
      <div class="footer-middle_area">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-8">
              <div class="footer-widgets_info row">
                <div class="col-md-6">
                  <div class="footer-widgets_logo">
                  <a href="#">
                    <img src="/images/menu/logo/1.png" alt="Uren's Footer Logo">
                  </a>
                </div>
                <div class="widget-short_desc">
                  <p>Quincaillerie Sahara was founded in 1990 and for more than twenty years has been the leading supplier of
                      tools and materials to companies in Mauritania. 
                  </p>
                </div>
                </div>
                <div class="widgets-essential_stuff col-md-6">
                  <ul>
                    <li class="uren-address"><span>Address:</span> <a href="#">Located on the road to 
                          the airport between the French Embassy and National Hospital, Quincaillerie Sahara
                          (Hardware Store Sahara) is easy to find, has off street parking and space to load trucks.</a></li>
                    <li class="uren-phone"><span>Call
                        Us:</span> <a href="tel://+123123321345">(222) 11 22 33 44</a>
                    </li>
                    <li class="uren-email"><span>Email:</span> <a
                        href="mailto://info@yourdomain.com">qsahara@gmail.com</a></li>
                  </ul>
                </div>

              </div>
            </div>

            <div class="col-md-4 text-center">
              <div class="uren-social_link">
                <ul>
                  <li class="facebook">
                    <a href="https://www.facebook.com/" data-toggle="tooltip" target="_blank" title="Facebook">
                      <i class="fab fa-facebook"></i>
                    </a>
                  </li>
                  <li class="twitter">
                    <a href="https://twitter.com/" data-toggle="tooltip" target="_blank" title="Twitter">
                      <i class="fab fa-twitter-square"></i>
                    </a>
                  </li>
                  <li class="google-plus">
                    <a href="https://www.plus.google.com/discover" data-toggle="tooltip" target="_blank"
                      title="Google Plus">
                      <i class="fab fa-google-plus"></i>
                    </a>
                  </li>
                  <li class="instagram">
                    <a href="https://rss.com/" data-toggle="tooltip" target="_blank" title="Instagram">
                      <i class="fab fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade modal-wrapper" id="exampleModalCenter">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <quick-view />
          </div>
        </div>
      </div>
    </div>
    <!-- Uren's Modal Area End Here -->
  </div>
</template>

<script>
import QuickView from './QuickView.vue'
export default {
  components: { QuickView },
  name: "Footer",
}
</script>

<style>

</style>
